import type UnifiedStorageQuotaNotificationPayload from "owa-service/lib/contract/UnifiedStorageQuotaNotificationPayload";
import type { MailboxInfo } from "owa-client-types";
import { action } from "satcheljs";

export interface UNIFIED_STORAGE_QUOTA_NOTIFICATIONActionMessage {
    notification: UnifiedStorageQuotaNotificationPayload;
    mailboxInfo: MailboxInfo; // Removed optional marker
}

export const unifiedStorageQuotaNotificationAction: (notification: UnifiedStorageQuotaNotificationPayload, mailboxInfo: MailboxInfo // Removed optional marker
) => UNIFIED_STORAGE_QUOTA_NOTIFICATIONActionMessage = action("UNIFIED_STORAGE_QUOTA_NOTIFICATION", (notification: UnifiedStorageQuotaNotificationPayload, mailboxInfo: MailboxInfo // Removed optional marker
): UNIFIED_STORAGE_QUOTA_NOTIFICATIONActionMessage => ({
    notification,
    mailboxInfo,
}));
